import Vue from "vue";
import {setStore, getStore, clearStore} from '../../config/mUtils'
import { prefix } from "../../config/env";
import { postRequest } from '../../api/base'
const COURSE_STAGE_SUBJECT_IN = 'COURSE_STAGE_SUBJECT_IN'// 写入题目
const COURSE_STAGE_SUBJECT_OUT = "COURSE_STAGE_SUBJECT_OUT"; // 删除写入
export default {
  state: JSON.parse(getStore(`${prefix}course_stage_subject`)) || null,
  mutations: {
    [COURSE_STAGE_SUBJECT_IN] (state, data) {
      let stringify = JSON.stringify(data);
      Object.assign(state, data);
      setStore(`${prefix}course_stage_subject`, stringify)
      postRequest("/wenjiaoopne/kc/user/setUserStageSubject",{stage_subject: stringify}).then(() => {})
    },
    [COURSE_STAGE_SUBJECT_OUT](state) {
      clearStore();
      Object.keys(state).forEach((k) => Vue.delete(state, k));
    }
  },
  actions: {
    [COURSE_STAGE_SUBJECT_IN] ({commit}, data) {
      commit(COURSE_STAGE_SUBJECT_IN, data)
    },
    [COURSE_STAGE_SUBJECT_OUT]({ commit }) {
      commit(COURSE_STAGE_SUBJECT_OUT);
    }
  }
}
